import React from "react";
import { Menu } from "antd";
import { NavLink, useRouteMatch } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import propTypes from "prop-types";
import { useHistory } from "react-router-dom";

const { SubMenu } = Menu;

const MenuItems = ({ darkMode, toggleCollapsed, topMenu, events }) => {
  const { path } = useRouteMatch();

  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split("/");
  const history = useHistory();
  const [openKeys, setOpenKeys] = React.useState(
    !topMenu
      ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : "dashboard"}`]
      : []
  );

  const onOpenChange = (keys) => {
    setOpenKeys(
      keys[keys.length - 1] !== "recharts"
        ? [keys.length && keys[keys.length - 1]]
        : keys
    );
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? "inline" : "horizontal"}
      theme={darkMode && "dark"}
      defaultSelectedKeys={
        !topMenu
          ? [
              `${
                mainPathSplit.length === 1
                  ? "home"
                  : mainPathSplit.length === 2
                  ? mainPathSplit[1]
                  : mainPathSplit[2]
              }`,
            ]
          : []
      }
      defaultOpenKeys={
        !topMenu
          ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : "dashboard"}`]
          : []
      }
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
      openKeys={openKeys}
    >
      <SubMenu
        key="manuales"
        icon={!topMenu && <FeatherIcon icon="settings" />}
        title="Tipo de Manuales"
      >
        <Menu.Item key="manuales">
          <NavLink onClick={toggleCollapsed} to={`${path}/type-manuals/view`}>
            Tipo de Manuales
          </NavLink>
        </Menu.Item>
      </SubMenu>

      <SubMenu
        key="concesionaria"
        icon={!topMenu && <FeatherIcon icon="home" />}
        title="Red Honda"
      >
        <Menu.Item key="dealers">
          <NavLink onClick={toggleCollapsed} to={`${path}/dealers/view`}>
            Concesionarios
          </NavLink>
        </Menu.Item>
        <Menu.Item key="sedes">
          <NavLink onClick={toggleCollapsed} to={`${path}/officess/view`}>
            Sede
          </NavLink>
        </Menu.Item>
      </SubMenu>

      <SubMenu
        key="users"
        icon={!topMenu && <FeatherIcon icon="users" />}
        title="Usuarios"
      >
        <Menu.Item key="users">
          <NavLink onClick={toggleCollapsed} to={`${path}/users/view`}>
            Usuarios
          </NavLink>
        </Menu.Item>
      </SubMenu>

      <SubMenu
        key="manuals"
        icon={!topMenu && <FeatherIcon icon="file-text" />}
        title="Manuales"
      >
        {/* <Menu.Item key="manuals">
          <NavLink onClick={toggleCollapsed} to={`${path}/manuals/view`}>
            Manuales
          </NavLink>
        </Menu.Item> */}
        <Menu.Item key="modelsWithManuals">
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/modelsWithManuals/view`}
          >
            Manuales y Catálogo
          </NavLink>
        </Menu.Item>
        <Menu.Item key="models">
          <NavLink onClick={toggleCollapsed} to={`${path}/models/view`}>
            Modelos
          </NavLink>
        </Menu.Item>
      </SubMenu>

      <SubMenu
        key="newsletter"
        icon={!topMenu && <FeatherIcon icon="file-plus" />}
        title="Boletines"
      >
        <Menu.Item key="newsletter">
          <NavLink onClick={toggleCollapsed} to={`${path}/newsletters/view`}>
            Boletin
          </NavLink>
        </Menu.Item>
      </SubMenu>

      <SubMenu
        key="logdownloads"
        icon={!topMenu && <FeatherIcon icon="package" />}
        title="Reportes"
      >
        <Menu.Item key="manualsdownloads">
          <NavLink onClick={toggleCollapsed} to={`${path}/reports/manuals`}>
            Descargas Manuales
          </NavLink>
        </Menu.Item>
        <Menu.Item key="newslettersdownloads">
          <NavLink onClick={toggleCollapsed} to={`${path}/reports/newsletters`}>
            Descargas Boletines
          </NavLink>
        </Menu.Item>
        <Menu.Item key="logusers">
          <NavLink onClick={toggleCollapsed} to={`${path}/reports/sessions`}>
            Tiempo de Sesión
          </NavLink>
        </Menu.Item>
      </SubMenu>

      {/* <SubMenu
        key="vins"
        icon={!topMenu && <FeatherIcon icon="layers" />}
        title="VINs"
      >
        <Menu.Item key="vins">
          <NavLink onClick={toggleCollapsed} to={`${path}/vins/view`}>
            VINs
          </NavLink>
        </Menu.Item>
        <Menu.Item key="upload">
          <NavLink onClick={toggleCollapsed} to={`${path}/vins/upload`}>
            Cargar VINs
          </NavLink>
        </Menu.Item>
      </SubMenu> */}
    </Menu>
  );
};

MenuItems.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
  toggleCollapsed: propTypes.func,
  events: propTypes.object,
};

export default MenuItems;
